import styled from "styled-components";
import { motion } from "framer-motion";

export const ContainerHome = styled.div`
  width: 100%;
  height: 100vh;
  height: 100dvh;
  overflow-y: auto;
`;

export const TextHome = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  height: 20%;
  .title-saludo {
    font-weight: 400;
    font-size: 24px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 22px;
    line-height: 150%;
    text-align: center;
    width: 365px;
  }
  .title-negrita {
    font-weight: bold;
  }
`;

export const BtnContainer = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 28px;
  max-width: 1200px;
  padding: 60px 40px;
  margin: 0 auto;

  overflow-y: scroll;
  ::-webkit-scrollbar {
    width: 10px;
  }

  ::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: var(--color-scrollbar);
  }

  svg {
    width: 30px;
    height: 30px;
    flex-shrink: 0;
  }

  /* Cada botón ocupa un ancho fijo o proporcional */
  > div {
    flex: 1 1 calc(33.333% - 28px);
    display: flex;
    justify-content: center;
  }

  /* Segunda fila (4to y 5to elemento) centrados */
  > div:nth-child(n + 4) {
    flex: 1 1 calc(33.333% - 28px);
  }

  /* Si hay solo 2 en la última fila, los centramos */
  > div:nth-child(4),
  > div:nth-child(5) {
    flex: 0 1 calc(33.333% - 28px);
  }

  @media (max-width: 768px) {
    width: 99%;
    margin: auto;
    margin-top: 10px;
    height: calc(100% - 20vh);
    height: calc(100% - 20dvh);
    display: flex;
    flex-direction: column;
    gap: 30px;
    padding: 20px 0 40px 0;
    flex-wrap: initial;
    svg {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
    }
  }
`;

export const HeaderHomeBar = styled(motion.div)`
  position: relative;
  width: 100%;
  height: 100px;
  color: var(--color-white);
  background-color: var(--color-latex10);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border-top: 4px solid var(--color-primary);
  text-align: center;

  .title {
    font-weight: 400;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-negrita {
    font-weight: 700;
    font-size: 20px;
    line-height: 150%;
    font-style: normal;
  }
  .title-pregunta {
    font-weight: 400;
    font-size: 18px;
    line-height: 150%;
  }

  h1 {
    padding: 0;
    margin: 0;
    text-align: center;
  }
  .container-ellipse {
    width: 100%;
    height: max-content;
    position: absolute;
    bottom: -50%;
    margin: auto;
    right: 0;
  }

  /* Tablet y Desktop: Header más alto y textos más grandes */
  @media (min-width: 768px) {
    height: 140px;
    gap: 8px;

    .title {
      font-size: 28px;
    }
    .title-negrita {
      font-size: 28px;
    }
    .title-pregunta {
      font-size: 24px;
    }
  }

  @media (min-width: 1200px) {
    height: 160px;
    gap: 12px;

    .title {
      font-size: 32px;
    }
    .title-negrita {
      font-size: 32px;
    }
    .title-pregunta {
      font-size: 26px;
    }
  }
`;

export const ContianerHome = styled(motion.div)`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  background-color: transparent;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;

  .redirection {
    position: absolute;
    height: max-content;
    width: max-content;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    padding-bottom: 20px;
    @media (max-height: 780px) {
      padding-bottom: 0px;
      height: 80px;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: -1;
    }
  }
  .logo-dim {
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: -2;

    /* Ajustar tamaño del logo en desktop */
    @media (min-width: 1200px) {
      svg {
        height: 400px;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0;
  }
  .selected {
    background-color: red;
  }
  .ptur-socialSidebar-burguer {
    width: 100%;
    position: initial;
    padding-top: 20px;
  }

  /* Tablet y Desktop: Centrar contenido */
  @media (min-width: 768px) {
    overflow-y: auto;

    ${BtnContainer} {
      align-self: center;
    }
  }
`;
